import React from 'react'
import { MapPin, Clock, Phone } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import BranchListData from './Data/BranchListData'
import { paths } from '../../../../routes/paths'

function SecondSection() {
  const navigate = useNavigate()
  
  const handleBranchClick = (branch) => {
    navigate(`${paths.branch}/${branch.name.replace(/\s+/g, '-').toLowerCase()}`);
  }

  return (
    <div className="min-h-screen text-white p-8">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600">
            PAPAKILO HAIRSTUDIO
          </h1>
          <p className="text-slate-400">Exclusive Locations</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {Object.entries(BranchListData).map(([city, locations]) => (
            <div key={city} className="cursor-pointer">
              <h2 className="text-2xl font-semibold mb-6 bg-gradient-to-br from-slate-900 to-slate-800 text-transparent bg-clip-text hover:text-white transition-colors duration-300">
                {city}
              </h2>
              <div className="grid gap-6">
                {locations.map((branch) => (
                  <div 
                    key={branch.name}
                    onClick={() => handleBranchClick(branch)}
                    className="rounded-lg border-2 border-slate-800 bg-transparent backdrop-blur-sm hover:scale-105 transition-transform ease-in-out duration-700 overflow-hidden"
                  >
                    <div className="p-6">
                      <h3 className="text-lg font-medium text-slate-800 transition-colors duration-300 mb-4">
                        {branch.name}
                      </h3>
                      <div className="space-y-4">
                          <div className="flex items-start space-x-3">
                            <MapPin className="w-5 h-5 text-red-800 mt-1" />
                            <p className="text-slate-800">{branch.address}</p>
                          </div>
                          <div className="flex items-center space-x-3">
                            <Clock className="w-5 h-5 text-amber-400" />
                            <p className="text-slate-800">{branch.hours}</p>
                          </div>
                          <div className="flex items-center space-x-3">
                            <Phone className="w-5 h-5 text-blue-400" />
                            <p className="text-slate-800">{branch.phone}</p>
                          </div>
                        </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default SecondSection